module.exports = "<input type=\"file\" class=\"file-input\"\n       [accept]=\"requiredFileType\"\n       (change)=\"onFileSelected($event)\" #fileUpload>\n\n<div class=\"file-upload\">\n\n   {{fileName || \"Выбрать файл\"}}\n\n    <button  class=\"btn btn--blue ml20\"\n      (click)=\"fileUpload.click()\">\n      <span class=\"icon icon--attach-file\"></span>\n    </button>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/components/file-upload/file-upload.component.html
// module id = ./src/app/view/components/file-upload/file-upload.component.html
// module chunks = main